'use strict';

var Stringify = require('./stringify');
var Parse = require('./parse');

module.exports = {
    stringify: Stringify,
    parse: Parse
};



//////////////////
// WEBPACK FOOTER
// ./~/qs/lib/index.js
// module id = 173
// module chunks = 1